/* eslint-disable no-throw-literal */
import notice from "../../utils/notice";
import { CONTENTS_URL, CONTENTS_URL_v2 } from "../helpers/routes";
import { getMultipartParams, handleResponse } from "../helpers/validate";
import { downloadCsv } from "../../utils/downloadCsv";

export const defaultContent = {
  name: "",
  description: "",
  content: null,
  content_type: "",
  author_name: "",
  focus_areas_ids: "",
  categories_id: "",
  moods_id: "",
  contributing_factors_id: "",
  image: null,
  logo: null,
  duration: "",
  duration_minutes: "",
  content_partner: "",
};

// TZ-807: fetch the content focus-area audit rows and download them as CSV.
export const downloadContentFocusAreaAudit = (
  onDone = () => {},
  onError = () => {}
) => {
  return fetch(`${CONTENTS_URL}/focus_area_audit`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .then((rows) => {
      const headers = [
        "Content name",
        "Type",
        "Focus areas",
        "Tagged to display in routine?",
      ];
      const data = (rows || []).map((r) => [
        r.name,
        r.content_type,
        r.focus_areas,
        r.display_in_routine,
      ]);
      const date = new Date().toISOString().slice(0, 10);
      downloadCsv(headers, data, `content_focus_area_audit_${date}.csv`);
      onDone();
    })
    .catch((e) => {
      console.error(e);
      notice("Error downloading focus-area audit");
      onError();
    });
};

export const getContents = (
  setterFunction,
  page = 1,
  zone_id = 1,
  query = "",
  pro_athlete = false,
  focus_area,
  per_page = 500
) => {
  let url = `list-category?category_id=${zone_id}&page=${page}&search_query=${query}&is_pro_athlete=${pro_athlete}&per_page=${per_page}`;
  if (!!focus_area && focus_area !== 0) {
    url = `list-category?category_id=${zone_id}&focus_area_id=${focus_area}&page=${page}&search_query=${query}&is_pro_athlete=${pro_athlete}&per_page=${per_page}`;
  }
  return fetch(`${CONTENTS_URL_v2}/${url}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .then((json) => setterFunction(json))
    .catch((e) => {
      notice("Error on loading content ");
      console.error(e);
      throw e;
    });
};

export const getContentsList = (setterFunction, page = 1, zone_id = 1) => {
  return fetch(CONTENTS_URL, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .then((json) => setterFunction(json.items))
    .catch((e) => {
      notice("Error on loading content ");
      console.error(e);
      throw e;
    });
};

export const getContent = (setterFunction, id) => {
  return fetch(`${CONTENTS_URL_v2}/show?id=${id}`, getMultipartParams("GET"))
    .then((res) => handleResponse(res))
    .then((json) => {
      setterFunction(json);
      return json;
    })
    .catch((e) => {
      notice("Error on loading content ");
      console.error(e);
      throw e;
    });
};

export const saveContent = (setterFunction, data) => {
  const formData = new FormData();

  for (const name in data) {
    if (Array.isArray(data.content) && name === "content") continue;
    formData.append(name, data[name]);
  }
  if (Array.isArray(data.content)) {
    for (const index in data.content) {
      formData.append("content" + index, data.content[index]);
    }
    formData.append("totalContents", data.content.length);
  }

  return fetch(
    `${CONTENTS_URL_v2}/create-content`,
    getMultipartParams("POST", formData)
  )
    .then((res) => handleResponse(res))
    .then((json) => {
      //TODO replace with api response
      /*if (json && json.id) {
      notice("Content created", "success")
      return setterFunction(json)
    } else {
      notice("Error saving the content")
      throw {error: json}
    }*/
      notice("Content created", "success");
    })
    .catch((e) => {
      notice("Error saving the content");
      console.error(e);
      throw e;
    });
};

export const updateContent = (setterFunction, data, id) => {
  const formData = new FormData();

  for (const name in data) {
    if (Array.isArray(data.content) && name === "content") continue;
    formData.append(name, data[name]);
  }

  if (Array.isArray(data.content)) {
    for (const index in data.content) {
      formData.append("content" + index, data.content[index]);
    }
    formData.append("totalContents", data.content.length);
  }

  return fetch(
    `${CONTENTS_URL_v2}/update?id=${id}`,
    getMultipartParams("PUT", formData)
  )
    .then((res) => handleResponse(res))
    .then((json) => {
      if (json && json.id) {
        notice("Content  updated", "success");
        return setterFunction(json);
      } else {
        notice("Error saving the content");
        throw { error: json };
      }
    })
    .catch((e) => {
      notice("Error saving the content");
      console.error(e);
      throw e;
    });
};

export const deleteContent = (id) => {
  return fetch(
    `${CONTENTS_URL_v2}/delete?id=${id}&active=false`,
    getMultipartParams("DELETE")
  )
    .then((res) => handleResponse(res))
    .then((json) => {
      notice("Content deleted", "success");
      return json;
    })
    .catch((e) => {
      notice("Error deleting the content");
      console.error(e);
      throw e;
    });
};
